import moment from 'moment';

import {FormattedTimestamp} from '../../timestamp/formatted-timestamp';
import type {Format} from '../../timestamp/formatted-timestamp';

export function getTimestampFormat(timestamp: number): Format {
    const isCurrentYear = moment.unix(timestamp).isSame(moment(), 'year');

    return isCurrentYear
        ? FormattedTimestamp.formats.shortMonthDayWithTimeCapitalized
        : FormattedTimestamp.formats.shortMonthDayWithYearWithTimeCapitalized;
}
